import React, { Component }  from 'react';
import {
  FilteringState, GroupingState,
  IntegratedGrouping, IntegratedPaging, IntegratedSorting, IntegratedFiltering,
  PagingState, SortingState, DataTypeProvider,
} from '@devexpress/dx-react-grid';
import {
  DragDropProvider,
  Grid, GroupingPanel, PagingPanel,
  Table, TableFilterRow, TableGroupRow,
  TableHeaderRow, Toolbar,
} from '@devexpress/dx-react-grid-material-ui';
import { GETMACHINESETTINGS, GETDOCUMENT } from '../../constants/Config';
import { toast } from 'react-toastify';
import { useTranslation, Trans } from 'react-i18next';
import { Button, TextField , Paper, Grid as MaterialGrid, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import EyeIcon from '@material-ui/icons/RemoveRedEye';
import DownLoadIcon from '@material-ui/icons/CloudDownload';
import IconButton from '@material-ui/core/IconButton';
const { t } = useTranslation();

const gridcolumns = [
    { name: 'momentSaved', title: <Trans>{t('momentSaved')}</Trans> },
    { name: 'stepName', title: <Trans>{t('stepName')}</Trans> },
    { name: 'pieceNumber', title: <Trans>{t('pieceNumber')}</Trans> },
    { name: 'productCodeWithBatchNumber', title: <Trans>{t('productCodeWithBatchNumber')}</Trans>},
    { name: 'fileName', title: <Trans>{t('fileName')}</Trans> },
    { name: 'actions', title: <Trans>{t('actions')}</Trans> },
];

const filteringStateColumnExtensions = [
    { columnName: 'actions', filteringEnabled: false },
  ];

const filtercolumns = ['momentSaved', 'stepName', 'pieceNumber', 'productCodeWithBatchNumber', 'fileName'];
const actionColumns = ['actions'];
const pageSizes = [10, 20, 50];

const tableMessages = {
    noData: <Trans>{t('noData')}</Trans>,
};
const groupingPanelMessages = {
    groupByColumn: <Trans>{t('groupByColumn')}</Trans>,
};
const filterRowMessages = {
    placeholder: <Trans>{t('filterPlaceholder')}</Trans>,
    contains: <Trans>{t('contains')}</Trans>,
    notContains: <Trans>{t('notContains')}</Trans>,
    startsWith: <Trans>{t('startsWith')}</Trans>,
    endsWith: <Trans>{t('endsWith')}</Trans>,    
    equal: <Trans>{t('equal')}</Trans>,
    notEqual: <Trans>{t('notEqual')}</Trans>,
    greaterThan: <Trans>{t('greaterThan')}</Trans>,
    greaterThanOrEqual: <Trans>{t('greaterThanOrEqual')}</Trans>,
    lessThan: <Trans>{t('lessThan')}</Trans>,
    lessThanOrEqual: <Trans>{t('lessThanOrEqual')}</Trans>
};

// const pagingPanelMessages = {
//     showAll: <Trans>{t('showAll')}</Trans>,
//     rowsPerPage: <Trans>{t('rowsPerPage')}</Trans>,
//     info: <Trans>{t('info')}</Trans>,
// };

const pagingPanelMessages = {
    showAll: "Toon alle",
    rowsPerPage: "Rijen per pagina",
    info: "{from} - {to} van {count}"
};

class CncInfoPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cncInfo: [],
            dialogVisible: false,
            DialogContent: "",
            DialogTitle: ""
        };
    }

    downloadQdocFile(documentID) {
        fetch(GETDOCUMENT + documentID, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }
        
                return data;
            });
        })
        .then((res) => {
            this.saveData(res.results[0].content , res.results[0].name);
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    saveData(data, fileName) {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        var blob = new Blob([data], {type: "octet/stream"})
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    };

    showQdocFile(documentID) {
        fetch(GETDOCUMENT + documentID, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }
        
                return data;
            });
        })
        .then((res) => {
            this.setState({ DialogTitle: res.results[0].name });
            this.setState({ DialogContent: res.results[0].content });
            this.setState({ dialogVisible: true });
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    componentDidMount() {
        let number = decodeURIComponent(this.props.match.params.ordernumber);
        this.props.setHeader(number);

        fetch(GETMACHINESETTINGS + this.props.match.params.productionOrderID, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }
        
                return data;
            });
        })
        .then((res) => {
            this.setState({
                cncInfo: res.results,
            });
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    handleCloseDialog = () => {
        this.setState({ dialogVisible: false });
    }

    ActionFormatter = (row) => (
        <React.Fragment>
            <IconButton color="secondary" variant="contained" aria-label="lookup" onClick={() => this.showQdocFile(row.row.documentID)}>
                <EyeIcon />
            </IconButton>
            <IconButton color="secondary" variant="contained" aria-label="download" onClick={() => this.downloadQdocFile(row.row.documentID)}>
                <DownLoadIcon />
            </IconButton>
        </React.Fragment>
    );

    render() {
        return (
            <div className="datagridWell">
                <Dialog maxWidth="md" fullWidth open={this.state.dialogVisible} onClose={this.handleCloseDialog} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{this.state.DialogTitle}</DialogTitle>
                    <DialogContent>
                        <TextField
                                multiline={true}
                                value={this.state.DialogContent}
                                disabled={true}
                                fullWidth/>  
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" onClick={this.handleCloseDialog}>
                            <Trans>{t('Close')}</Trans>
                        </Button>
                    </DialogActions>
                </Dialog>

                <Paper>
                    <Grid rows={this.state.cncInfo} columns={gridcolumns}>
                        <FilteringState columnExtensions={filteringStateColumnExtensions}/>
                        <SortingState />                        
                        <GroupingState />
                        <PagingState />
                        <IntegratedGrouping />
                        <IntegratedFiltering />
                        <IntegratedSorting />
                        <IntegratedPaging />
                        <DragDropProvider />
                        <DataTypeProvider formatterComponent={this.ActionFormatter} for={actionColumns} />
                        <Table messages={tableMessages} />
                        <TableHeaderRow showSortingControls={true} />
                        <TableFilterRow showFilterSelector={true} messages={filterRowMessages}/>
                        <Toolbar />
                        <GroupingPanel showSortingControls={true} messages={groupingPanelMessages}/>
                        <TableGroupRow />
                        <PagingPanel pageSizes={pageSizes} messages={pagingPanelMessages}/>
                    </Grid>
                </Paper>
            </div>
        )
    }
}

export default CncInfoPage;